import api from "./axios";

const BASE = "/rider-documents";

export const listApprovalSummary = async (params = {}) => {
  return api.get(`${BASE}/approval-summary`, { params });
};

export const listRiderDocuments = async (riderId) => {
  return api.get(`${BASE}/rider/${riderId}`);
};

export const approveDocument = async (id) => {
  return api.put(`${BASE}/${id}/approve`);
};

export const rejectDocument = async (id, payload) => {
  return api.put(`${BASE}/${id}/reject`, payload);
};

export const replaceDocument = async (id, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.put(`${BASE}/${id}/replace`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const adminUploadDocument = async (riderId, documentType, file) => {
  const form = new FormData();
  form.append("riderId", riderId);
  form.append("documentType", documentType);
  form.append("file", file);
  return api.post(`${BASE}/admin-upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const resetDocumentLock = async (id) => {
  return api.put(`${BASE}/${id}/reset`);
};

export const approveAllForRider = async (riderId) => {
  return api.put(`${BASE}/rider/${riderId}/approve-all`);
};

export const bulkApproveDocuments = async (ids) => {
  return api.post(`${BASE}/bulk-approve`, { ids });
};

export const exportDocumentApproval = async (params = {}) => {
  return api.get(`${BASE}/export`, {
    params,
    responseType: "blob",
  });
};

export const downloadDocumentFile = async (id) => {
  return api.get(`${BASE}/${id}/file`, {
    responseType: "blob",
  });
};
